module.exports = __webpack_public_path__ + "static/media/copy.923d9605.svg";